import React from "react";
import PropTypes from "prop-types";

// Función para estandarizar la fecha a dd-mm-aaaa
const estandarizarFecha = (fecha) => {
  const [dia, mes, ano] = fecha.split("-");
  const anoFormateado = ano.length === 2 ? `20${ano}` : ano;
  return `${dia.padStart(2, "0")}-${mes.padStart(2, "0")}-${anoFormateado}`;
};

// Función para estandarizar la hora a hh:mm
const estandarizarHora = (hora) => {
  if (hora.includes(".")) {
    return hora.replace(".", ":");
  }
  return hora;
};

const formatearFecha = (dia, mes, ano) => {
  const mesFormateado = mes.padStart(2, "0");
  const diaFormateado = dia.padStart(2, "0");
  const anoFormateado = ano.length === 2 ? `20${ano}` : ano;

  return `${diaFormateado}-${mesFormateado}-${anoFormateado}`;
};

const esFechaInvalida = (dia, mes, ano) => {
  return dia === "N/A" || mes === "N/A" || ano === "N/A";
};

const calcularHorasTrabajadas = (horaEntrada, horaSalida) => {
  if (
    horaEntrada === "AUSENTE" ||
    horaSalida === "AUSENTE" ||
    horaEntrada === "N/A" ||
    horaSalida === "N/A"
  ) {
    return "0:00";
  }

  const [horaE, minutoE] = estandarizarHora(horaEntrada).split(":").map(Number);
  const [horaS, minutoS] = estandarizarHora(horaSalida).split(":").map(Number);

  if (isNaN(horaE) || isNaN(minutoE) || isNaN(horaS) || isNaN(minutoS)) {
    return "NaN:NaN";
  }

  let horasTrabajadas = horaS - horaE;
  let minutosTrabajados = minutoS - minutoE;

  if (minutosTrabajados < 0) {
    minutosTrabajados += 60;
    horasTrabajadas -= 1;
  }

  if (horasTrabajadas < 0) {
    horasTrabajadas += 24;
  }

  return `${horasTrabajadas}:${minutosTrabajados.toString().padStart(2, "0")}`;
};

const esHorasTrabajadasFueraRango = (horasTrabajadas) => {
  const [horas, minutos] = horasTrabajadas.split(":").map(Number);
  return (
    horas > 10 || (horas < 4 && horas !== 0) || horasTrabajadas === "NaN:NaN"
  );
};

const esCodigoInvalido = (codigo) => {
  if (!codigo || codigo === "N/A") return true;
  const regex = /^[0-9kK\-]+$/;
  if (!regex.test(codigo)) return true;
  const partes = codigo.split("-");
  if (partes.length > 2 || (partes[1] && partes[1].length > 1)) return true;
  return false;
};

const Table = ({ resultados, reintentarEnvio, openModal }) => {
  if (!resultados) {
    return <div>No hay datos disponibles</div>;
  }

  const esHoraInvalida = (hora) => {
    return hora === "N/A" || hora === "";
  };

  return (
    <div className="tabla-responsiva">
      <table>
        <thead>
          <tr>
            <th>Nombre Archivo</th>
            <th>Código</th>
            <th>Nombre</th>
            <th>RUT</th>
            <th>Día</th>
            <th>Hora Entrada</th>
            <th>Hora Salida</th>
            <th>Horas Trabajadas</th>
            <th>Observaciones</th>
          </tr>
        </thead>
        <tbody>
          {resultados.estado === "error" ? (
            <tr>
              <td colSpan="10">
                Error al procesar archivo {resultados.archivoName}:{" "}
                {resultados.mensajeError}
                <span className="icono-error">&#10060;</span>
                <button onClick={() => reintentarEnvio(resultados.archivoName)}>
                  Reintentar
                </button>
                <button
                  onClick={() =>
                    openModal({ archivoURL: resultados.archivoURL }, "pdf")
                  }
                >
                  Ver Archivo
                </button>
              </td>
            </tr>
          ) : resultados.estado === "reintentando" ? (
            <tr>
              <td colSpan="10">
                Reintentando archivo {resultados.archivoName}...
                <span className="icono-actualizando"></span>
              </td>
            </tr>
          ) : resultados.Asistencia.length === 0 ? (
            <tr>
              <td colSpan="10">
                Procesando archivo {resultados.archivoName}...
                <span className="icono-actualizando"></span>
              </td>
            </tr>
          ) : (
            <>
              {resultados.Asistencia.map((asistencia, index) => {
                const horaEntrada = asistencia.HORA_ENTRADA;
                const horaSalida = asistencia.HORA_SALIDA;
                const horasTrabajadas =
                  !esHoraInvalida(horaEntrada) && !esHoraInvalida(horaSalida)
                    ? calcularHorasTrabajadas(horaEntrada, horaSalida)
                    : null;
                const esInvalida =
                  esFechaInvalida(
                    asistencia.DIA,
                    asistencia.MES,
                    asistencia.ANO
                  ) ||
                  (esHoraInvalida(horaEntrada) && esHoraInvalida(horaSalida));
                const esHorasFueraRango =
                  horasTrabajadas && esHorasTrabajadasFueraRango(horasTrabajadas);
                const esCodigoErroneo = esCodigoInvalido(asistencia.CODIGO);

                return (
                  <tr
                    key={index}
                    className={
                      esInvalida || esHorasFueraRango || esCodigoErroneo
                        ? "fila-error"
                        : ""
                    }
                  >
                    <td data-label="Nombre Archivo">
                      {resultados.archivoName}
                    </td>
                    <td data-label="Código">{asistencia.CODIGO}</td>
                    <td data-label="Nombre">{asistencia.NOMBRE}</td>
                    <td data-label="RUT">{asistencia.RUT}</td>
                    <td data-label="Día">
                      {formatearFecha(
                        asistencia.DIA,
                        asistencia.MES,
                        asistencia.ANO
                      )}
                    </td>
                    <td data-label="Hora Entrada">
                      {estandarizarHora(asistencia.HORA_ENTRADA)}
                    </td>
                    <td data-label="Hora Salida">
                      {estandarizarHora(asistencia.HORA_SALIDA)}
                    </td>
                    <td data-label="Horas Trabajadas">
                      {horasTrabajadas || "N/A"}
                    </td>
                    <td data-label="Observaciones">
                      {asistencia.OBSERVACIONES}
                    </td>
                  </tr>
                );
              })}
              {resultados.estado !== "procesando" && (
                <tr>
                  <td colSpan="10">
                    <button
                      onClick={() => reintentarEnvio(resultados.archivoName)}
                    >
                      Reintentar
                    </button>
                    <button
                      onClick={() =>
                        openModal({ archivoURL: resultados.archivoURL }, "pdf")
                      }
                    >
                      Ver Archivo
                    </button>
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  resultados: PropTypes.shape({
    archivoName: PropTypes.string.isRequired,
    estado: PropTypes.string.isRequired,
    archivoURL: PropTypes.string.isRequired,
    Asistencia: PropTypes.arrayOf(
      PropTypes.shape({
        CODIGO: PropTypes.string.isRequired,
        NOMBRE: PropTypes.string.isRequired,
        RUT: PropTypes.string,
        DIA: PropTypes.string.isRequired,
        HORA_ENTRADA: PropTypes.string.isRequired,
        HORA_SALIDA: PropTypes.string.isRequired,
        OBSERVACIONES: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
  reintentarEnvio: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
};

export default Table;
